/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ef498e19a9a1e1237c14d72c7d2877f25cad702e";
